import { Spinner } from '@/icons'

import { preview } from '@/components/form/preview'

import { useTexts } from '../useTexts'

export function Loading() {
  const texts = useTexts()

  return (
    <preview.Section alignItems="center">
      <Spinner size={24} animation="spin" />
      <preview.SectionTitle>{texts.loading}</preview.SectionTitle>
    </preview.Section>
  )
}
